import "../style/cart/Cart.css";
import img1 from "../../assets/cart/credit-card.png";
import { useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { useSelector } from "react-redux";

let discount_code_list = [
  {
    id: 1,
    code: "12dr57",
    discount: 0.1,
  },
  {
    id: 2,
    code: "12d8887",
    discount: 0.2,
  },
  {
    id: 3,
    code: "sd34890",
    discount: 0.05,
  },
];

const Cart = () => {
  const state = useSelector((state) => state.default);
  // const [data,set_data]=useState(state.CartData);
  // console.log(state.ExamData);
  // console.log(state.data);

  let data = state.ExamData.filter((item) => state.CartData.includes(item.id));

  
  
  // ----total-price----------------------
  let total_price = 0;
  for (let i = 0; i < data.length; i++) {
    if (data[i].badge) {
      total_price += data[i].price;
    } else {
      total_price += data[i].masterPrice;
    }
  }
  //-------discount----------------------
  const [discount, set_discount] = useState(0);
  const get_discount = () => {
    let code = document.querySelector("#discount-code-input").value;
    for (let j = 0; j < discount_code_list.length; j++) {
      if (code === discount_code_list[j].code) {
        set_discount(discount_code_list[j].discount);
      }
    }
  };

  //----payable-cost--and discount-amount------------------
  let discount_amount = discount * total_price;
  let payable_cost = total_price - discount_amount;

  return (
    <div className="cart">
      <div className="cart-title">سبد خرید</div>
      <div className="cart-payment-box">
        <div className="cart-payment-box-discount-box">
          <div className="cpbdb-btn" onClick={get_discount}>
            ثبت کد
          </div>
          <input
            className="cpbdb-input"
            type="text"
            name="discount-code"
            id="discount-code-input"
            placeholder="اگر کد تخفیف دارید اینجا بنویسید"
          />
        </div>
        <div className="cart-payment-box-line"></div>
        <div className="cart-payment-box-total-cost-box">
          <div className="cpbtcb-title">جمع مبالغ</div>
          <div className="cpbtcb-amount">
            {" "}
            {total_price} <span>تومان</span>
          </div>
        </div>
        <div className="cart-payment-box-discount-amount-box">
          <div className="cpbdab-title">میزان تخفیف</div>
          <div className="cpbdab-amount">
            {discount_amount} <span>تومان</span>
          </div>
        </div>
        <div className="cart-payment-box-line"></div>
        <div className="cart-payment-box-payable-cost-box">
          <div className="cpbpcb-title">مبلغ پرداختی</div>
          <div className="cpbpcb-amount">
            {payable_cost} <span>تومان</span>
          </div>
        </div>
        <div className="cart-payment-box-line"></div>
        <div className="cart-payment-box-description-box">
          <div className="cart-payment-box-description-box-text">
            پرداخت با کلیه کارت های عضو شبکه شتاب
          </div>
          <img src={img1} alt="card-img" />
        </div>
        <div className="cart-payment-box-btn">پرداخت</div>
      </div>
      <div className="cart-item-box">
        <div className="cart-item-box-title-row">
          <div className="cart-item-box-title-row-item cibtri-number">ردیف</div>
          <div className="cart-item-box-title-row-item cibtri-name">
            نام آزمون
          </div>
          <div className="cart-item-box-title-row-item cibtri-description">
            توضیحات
          </div>
          <div className="cart-item-box-title-row-item cibtri-price">مبلغ</div>
          <AiOutlineDelete className="cart-item-box-title-row-item-delete-icon" />
        </div>
        {data.map((item, index) => (
          <div key={item.id} className="art-item-box-item-row">
            <div className="cart-item-box-item-row-item cibiri-number">
              {index + 1}
            </div>
            <div className="cart-item-box-item-row-item cibiri-name">
              {item.name}
            </div>
            <div className="cart-item-box-item-row-item cibiri-description">
              {item.text}
            </div>
            <div className="cart-item-box-item-row-item cibiri-price">
              {item.badge ? item.price : item.masterPrice}{" "}
              <span>تومان</span>
            </div>
            <AiOutlineDelete className="cart-item-box-item-row-item-delete-icon" />
          </div>
        ))}
        <div className="cart-item-box-total-cost-row">
          <div className="cart-item-box-total-cost-row-item cibtcri-number"></div>
          <div className="cart-item-box-total-cost-row-item cibtcri-name"></div>
          <div className="cart-item-box-total-cost-row-item cibtcri-description"></div>
          <div className="cart-item-box-total-cost-row-item cibtcri-price">
            جمع مبالغ: {total_price} <span>تومان</span>
          </div>
          <AiOutlineDelete className="cart-item-box-total-cost-item-delete-icon" />
        </div>
      </div>
    </div>
  );
};

export default Cart;
